// pages/tasks/hooks/useTaskOperations.ts
import { useState, useCallback } from "react";
import { Task } from "@/types";
import { TASK_PRIORITIES, TASK_STATUS, FREQUENCY_OPTIONS } from "@/utils/constants";

export const useTaskOperations = (updateTask?: (taskId: string, updates: Partial<Task>) => Promise<void>) => {
  const [editingCell, setEditingCell] = useState<{
    taskId: string;
    columnKey: string;
  } | null>(null);

  const handleExistingTaskChange = useCallback(async (taskId: string, key: keyof Task, value: any) => {
    try {
      if (updateTask) {
        await updateTask(taskId, { [key]: value });
      }
    } catch (error) {
      console.error("Failed to update task:", error);
    }
  }, [updateTask]);

  return {
    editingCell,
    setEditingCell,
    handleExistingTaskChange,
  };
};